import { render, staticRenderFns } from "./WaveSurfer.vue?vue&type=template&id=8ab7e5f2&scoped=true"
import script from "./WaveSurfer.vue?vue&type=script&lang=js"
export * from "./WaveSurfer.vue?vue&type=script&lang=js"
import style0 from "./WaveSurfer.vue?vue&type=style&index=0&id=8ab7e5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab7e5f2",
  null
  
)

export default component.exports